import {ACTION_CODE} from './_actionCode';
import {TrainingAttachementService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DELETE_TRAINING_ATTACHMENT';

export async function deleteTrainingAttachment(userData: Record<string, string>, id: string) {
    try {
        LoggerService.logInfo('Action - deleteTrainingAttachment - Start');

        const deleteTrainingAttachmentResult = await TrainingAttachementService.deleteTrainingAttachment(userData, id);

        LoggerService.logInfo('Action - deleteTrainingAttachment - End - Success');

        return ResultModel.newSuccessResult(deleteTrainingAttachmentResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - deleteTrainingAttachment - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
